<template>
    <div class="form-pack">
        <h2 class="pack-pretitle">Garantie satisfaction</h2>
        <div class="pack-illu pack-illu-iban">
            <div>
                <img src="/images/new_branding/pack-garantie.png">
                <h3 class="pack-title">2€ seulement. <br>
                    Facile à résilier</h3>
            </div>
        </div>
        <div class="pack-iban">
            <p>Chez Testachats, pas question de vous garder lié à un abonnement contre votre volonté. Grâce à notre garantie de satisfaction, vous êtes libre de mettre fin à votre affiliation quand vous le souhaitez. Il vous suffira de nous en avertir au plus tard 15 jours ouvrables avant chaque échéance mensuelle de votre abonnement*.</p>
            <p>Il n'y a donc pas d'obligation d'achat définitif puisque vous pouvez annuler votre abonnement à votre gré sans devoir nous fournir la moindre explication.</p>
            <p>*Attention: tout mois entamé est considéré comme un mois entier.</p>
        </div>

    </div>
</template>

<script>
import image_mixin from "./mixins/image_mixin";

export default {
    name: "PackComponentIban",
    mixins:[
        image_mixin
    ]
}
</script>

<style lang="scss" scoped>

</style>
